import { rest } from 'msw'
export default [
  /**
   * チェーン情報
   */
  rest.post('/api/v2/get_chain_info', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          chainId: 7,
          chainName: '阪急OASIS',
          chainKey: 'inageya',
          chainLogo: 'https://placehold.jp/150x150.png',
          serviceName: 'LINEmini for 阪急OASIS',
          serviceFullName: 'LINEmini for 阪急OASIS',
          serviceLogo:
            'https://upload.wikimedia.org/wikipedia/en/thumb/e/ed/Nyan_cat_250px_frame.PNG/220px-Nyan_cat_250px_frame.PNG',
          tutorialPattern: '阪急OASIS',
          pointName: 'ポイントPoint',
          emoneyName: null,
          cardName: 'マムハートカード',
          callName: 'マルイお客様相談室',
          callTel: null,
          callMail: null,
          callUrl: 'https://www.hankyu-oasis.co.jp/contact.html',
          card: {
            isRegist: 1,
            displayCardNo: '34011111102',
            cardNoSample: null,
            cardNoLength: null,
            authKeys: [
              {
                key: 'pincode',
                name: 'PIN',
              },
            ],
            cardNote:
              '※ポイント特典の付与はお買上日の約２日後を予定しています。\n※ポイントカードをはじめてお作りになられた方は、作成から2週間程度お時間がかかる場合がございますので、あらかじめご了承ください。\n※ポイントの反映状況は「設定」にある「アプリ内ポイント付与履歴」をご確認ください。',
          },
          dispBalance: {
            point: 1,
            emoney: 1,
            expirePoint: 0,
            usageAmount: 0,
          },
          responseTime: 1599268730,
        },
      })
    )
  }),
  /**
   * チェーン情報
   */
  rest.get('/api/v2/get_chain_info', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          chain: {
            chainId: 1,
            chainName: 'ボーナス',
            serviceName: 'デジタルポイントプラス',
            serviceFullName: 'デジタルポイントプラス by Myトク',
            serviceLogo:
              'https://content.retailstudio.jp/images/0001/service_logo.jpg',
            tutorialPattern: 0,
            pointName: 'ボーナスポイント',
            cardName: 'ing・fanカード',
            callName: 'ing・fanカード コールセンター',
            callTel: '0120-xxxx-xxxx',
            callMail: '',
            callUrl: '',
            card: {
              isRegist: 1,
              displayCardNo: 'xxxx xxxxx xxxx 1235',
              cardNoSample: 'XXXX XXXX XXXX XXXX',
              cardNoLength: 12,
              cardNote:
                '① 現在のポイントはお買上げレシートの総ポイントでご確認ください。\n② ポイント特典の付与は毎週土曜日を予定しています。詳細は「設定」からご確認ください。',
            },
          },
          responseTime: '915148799',
        },
      })
    )
  }),
  /**
   * チェーン情報
   */
  rest.get('/api/v2/get_chain_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          chains: [
            {
              chainId: 1,
              chainName: 'ボーナス',
              serviceName: 'デジタルポイントプラス',
              serviceFullName: 'デジタルポイントプラス by Myトク',
              serviceLogo:
                'https://content.retailstudio.jp/images/0001/service_logo.jpg',
              tutorialPattern: 0,
              pointName: 'ボーナスポイント',
              cardName: 'ing・fanカード',
              callName: 'ing・fanカード コールセンター',
              callTel: '0120-xxxx-xxxx',
              callMail: '',
              callUrl: '',
              card: {
                isRegist: 1,
                displayCardNo: 'xxxx xxxxx xxxx 1234',
                cardNoSample: 'XXXX XXXX XXXX XXXX',
                cardNoLength: 12,
              },
            },
            {
              chainId: 1,
              chainName: 'ボーナス1',
              serviceName: 'デジタルポイントプラス',
              serviceFullName: 'デジタルポイントプラス by Myトク',
              serviceLogo:
                'https://content.retailstudio.jp/images/0001/service_logo.jpg',
              tutorialPattern: 0,
              pointName: 'ボーナスポイント',
              cardName: 'ing・fanカード',
              callName: 'ing・fanカード コールセンター',
              callTel: '0120-xxxx-xxxx',
              callMail: '',
              callUrl: '',
              card: {
                isRegist: 0,
                displayCardNo: 'xxxx xxxxx xxxx 1234',
                cardNoSample: 'XXXX XXXX XXXX XXXX',
                cardNoLength: 12,
              },
            },
            {
              chainId: 1,
              chainName: 'ボーナス2',
              serviceName: 'デジタルポイントプラス',
              serviceFullName: 'デジタルポイントプラス by Myトク',
              serviceLogo:
                'https://content.retailstudio.jp/images/0001/service_logo.jpg',
              tutorialPattern: 0,
              pointName: 'ボーナスポイント',
              cardName: 'ing・fanカード',
              callName: 'ing・fanカード コールセンター',
              callTel: '0120-xxxx-xxxx',
              callMail: '',
              callUrl: '',
              card: {},
            },
          ],
          responseTime: '915148799',
        },
      })
    )
  }),
  /**
   * チェーン店舗一覧情報
   */
  rest.post('/api/v2/get_chainshop_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          prefectures: [
            {
              prefectureName: '東京都',
              cities: [
                {
                  cityName: '品川区',
                  shops: [
                    {
                      shopId: 1,
                      shopCode: 1,
                      shopName: '大崎1店',
                      shopUrl: 'https://www.google.com/',
                      address: '東京都品川区大崎1-1-1',
                      lat: 35.6202167,
                      lng: 139.7179602,
                      enableSelect: 1,
                    },
                    {
                      shopId: 2,
                      shopCode: 2,
                      shopName: '大崎2店',
                      shopUrl: 'https://www.google.com/',
                      address: '東京都品川区大崎1-1-1',
                      lat: 35.6202167,
                      lng: 139.7179602,
                      enableSelect: 1,
                    },
                  ],
                },
                {
                  cityName: '立川市',
                  shops: [
                    {
                      shopId: 3,
                      shopCode: 3,
                      shopName: '立川1店',
                      shopUrl: 'https://www.google.com/',
                      address: '東京都立川市1',
                      lat: 35.6202167,
                      lng: 139.7179602,
                      enableSelect: 1,
                    },
                    {
                      shopId: 4,
                      shopCode: 4,
                      shopName: '立川2店',
                      shopUrl: 'https://www.google.com/',
                      address: '東京都立川市1',
                      lat: 35.6202167,
                      lng: 139.7179602,
                      enableSelect: 1,
                    },
                  ],
                },
              ],
            },
            {
              prefectureName: '神奈川',
              cities: [
                {
                  cityName: '横浜市',
                  shops: [
                    {
                      shopId: 5,
                      shopCode: 5,
                      shopName: '横浜1店',
                      shopUrl: 'https://www.google.com/',
                      address: '神奈川県横浜市',
                      lat: 35.6202167,
                      lng: 139.7179602,
                      enableSelect: 1,
                    },
                  ],
                },
                {
                  cityName: '川崎市',
                  shops: [
                    {
                      shopId: 6,
                      shopCode: 6,
                      shopName: '川崎1店',
                      shopUrl: 'https://www.google.com/',
                      address: '神奈川県川崎市',
                      lat: 35.6202167,
                      lng: 139.7179602,
                      enableSelect: 1,
                    },
                  ],
                },
              ],
            },
          ],
        },
      })
    )
  }),
  /**
   * チェーン店舗位置検索
   */
  rest.post('/api/v2/search_chainshop', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          shops: [
            {
              shopId: 3,
              shopCode: 3,
              shopName: '立川1店',
              shopUrl: 'https://www.google.com/',
              address: '東京都立川市1',
              lat: 35.6202167,
              lng: 139.7179602,
              enableSelect: 1,
            },
            {
              shopId: 4,
              shopCode: 4,
              shopName: '立川2店',
              shopUrl: 'https://www.google.com/',
              address: '東京都立川市1',
              lat: 35.6202167,
              lng: 139.7179602,
              enableSelect: 1,
            },
          ],
          responseTime: '915148799',
        },
      })
    )
  }),
]
